import { render, staticRenderFns } from "./BookingPrestaIssueEditDialog.vue?vue&type=template&id=713b9648&scoped=true"
import script from "./BookingPrestaIssueEditDialog.vue?vue&type=script&lang=js"
export * from "./BookingPrestaIssueEditDialog.vue?vue&type=script&lang=js"
import style0 from "./BookingPrestaIssueEditDialog.vue?vue&type=style&index=0&id=713b9648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b9648",
  null
  
)

export default component.exports